<template>
  <right-panel :datas="connects" ref="rightPanel" @onClose="onClose" :hideFooter="true">
    <div slot="header">
      <translate>Online Sessions</translate>
    </div>
    <div slot="content" class="online">
      <el-table
          :data="onlineConnection"
          style="width: 100%">
        <el-table-column
            :label="attrText.member">
          <template scope="scope">
            <img class="account-photo" :src="scope.row.account.avatar|resetURL"/>
            <span>{{scope.row.account.name}}</span>
          </template>
        </el-table-column>
        <el-table-column width="20" label=" ">
          <template scope="scope">
            <div>
              <el-tooltip class="unsafe-icon" effect="dark" :content="attrText.unsafeMode" placement="top" v-if="!scope.row.safe_mode">
                <i class="fa fa-exclamation-circle warn"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="tunnel_code"
            label="Code">
        </el-table-column>
        <el-table-column
            label="IP">
          <template scope="scope">
            {{scope.row.wetty_ip?scope.row.wetty_ip:scope.row.peer_ip}}
          </template>
        </el-table-column>
        <el-table-column
            width="120"
            :label="attrText.createTime">
          <template scope="scope">
            <div style="width: 80px;white-space: normal;">
              {{scope.row.create_time * 1000|moment('YYYY-MM-DD HH:mm:ss')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            :label="attrText.action">
          <template scope="scope">
            <div>
              <el-button :disabled="!(scope.row.way=='terminal' || scope.row.way=='wetty' || (scope.row.way=='rdp' && scope.row.showRdp))"
                          @click="onLinkhref(scope.row.linkHref)"
                          type="text"
                          v-if=" resourceType === 'ecs' && scope.row.agentVersion < '3.0.0'"
                          target="_blank">
                <translate>Monitor</translate>
              </el-button>
              <el-button :disabled="!(scope.row.way=='terminal' || scope.row.way=='wetty' || (scope.row.way=='rdp' && scope.row.showRdp))"
                          type="text"
                          v-if="resourceType === 'ecs' && scope.row.agentVersion >= '3.0.0'"
                          target="_blank">
                <span v-if="scope.row.way==='terminal' || scope.row.way==='wetty'"  @click="createShadow(scope.row)"><translate>assistance</translate></span>
                <span v-if="(scope.row.way==='rdp' && scope.row.showRdp)"  @click="onLinkhref(scope.row.linkHref)"><translate>monitor</translate></span>
              </el-button>
            </div>
            <el-button type="text" @click.stop="cutOnline(scope.row.id)"><translate>Disconnect</translate></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </right-panel>
</template>
<script>
import RightPanel from '../../common/right-panel'
import STORE_CONST from '../../../store/consts'
import { baseUrl } from '../../../config'
import Utility from '../../../Utils'
import Base64 from 'js-base64'
export default {
  name: 'WorkGroupOnlineConnection',
  props: {
    items: {
      required: true
    }
  },
  data () {
    return {
      connects: null,
      onlineConnection: null,
      resourceType: this.$route.query.type
    }
  },
  computed: {
    attrText () {
      return this.getTranslateText()
    },
    languageCurrent () {
      return this.$language.current
    },
    currentConnectList () {
      return this.$store.getters.dashboard.onlineMembers
    }
  },
  mounted () {
  },
  methods: {
    getTranslateText () {
      return {
        member: this.$gettext('Member'),
        createTime: this.$gettext('Create Time'),
        action: this.$gettext('Action'),
        'unsafeMode': this.$gettext('Unsafe Mode')
      }
    },
    onLinkhref (url) {
      window.open(url)
    },
    createShadow (con) {
      let params = {
        master_connection_id: con.connection_id,
        readonly: false,
        expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60
      }
      var newWin = window.open('')
      this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CSOS_SHADOW, params).then(res => {
        let shadowUrl = 'http://' + res.agent_host + ':' + res.agent_webtty_port + '/?code=' + Base64.Base64.encode(res.code) + '&user=' + res.user
        newWin.location.href = shadowUrl
      }, () => {
        newWin.close()
      })
    },
    onClose () {
      this.connects = null
      this.$emit('onClosePanel')
      this.$emit('reloadOnlineConnects')
    },
    // 获取该资源的在线连接列表
    getResourceOnlineConnects (id) {
      let params = {
        q_project: this.$route.params.id,
        q_resource: id
      }
      this.$store.dispatch(STORE_CONST.WORKGROUP.GET_WORKGROUP_RESOURCE_ONLINE_CONNECTS, params).then((res) => {
        let _connectList = Object.clone(res.objects)
        _connectList.forEach((item, index) => {
          let linkHref = ''
          if (item.guacamole && item.guacamole === 1) { // gucamole 类型的rdp 监视
            linkHref = 'http://' + item.host + ':' + item.webrdp_port + '/?code=' + Base64.Base64.encode(item.tunnel_code) + '&ip=' + item.resource_ip_address + '&resourceName=' + item.resource_name
          } else { // 旧的类型的rdp 以及 terminal 类型
            linkHref += 'playlog.html'
            linkHref += '?link=' + baseUrl.apiUrl
            linkHref += '&way=' + item.way
            linkHref += '&code=' + item.tunnel_code
            linkHref += '&lang=' + this.languageCurrent
            linkHref += '&type=monitor'
          }
          if (item.connection_id) {
            linkHref += '&connection_id=' + item.connection_id
          }
          item.linkHref = linkHref
          let showRdp = false
          if (Utility.Utils.getAgentVersion(item.agent_version) >= '2.4.2') {
            showRdp = true
          }
          item.agentVersion = Utility.Utils.getAgentVersion(item.agent_version)
          item.showRdp = showRdp
        })
        this.onlineConnection = _connectList
      })
    },
    cutOnline (id) {
      this.$confirm(this.$gettext('Are you sure to disconnect this connection?'), this.$gettext('Disconnect connection confirm'), {
        confirmButtonText: this.$gettext('Ok'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch(STORE_CONST.DASHBOARD.CUT_ONLINE, id).then(() => {
          let copy = Object.clone(this.currentConnectList)
          const deleteItem = copy.find((item) => {
            return item.id === id
          })
          copy.remove(deleteItem)
          this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, copy)
          let copyCount = Object.clone(this.$store.getters.dashboard.onlineMembersCount)
          this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - 1)
          this.$notify({
            type: 'success',
            message: this.$gettext('Disconnect successfully!')
          })
        }).catch((err) => {
          this.$notify.info({
            message: err
          })
        })
      })
    }
  },
  created () {
  },
  watch: {
    'items': {
      handler: function (newVal) {
        if (this.connects) {
          this.connects = null
          setTimeout(() => {
            this.connects = this.items
            this.getResourceOnlineConnects(this.connects.id)
          }, 300)
        } else {
          this.connects = this.items
          this.getResourceOnlineConnects(this.connects.id)
        }
      },
      deep: true
    }
  },
  components: {
    RightPanel
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
  .online{
    .el-button--text{
      margin-left: 0;
    }
    .el-table .cell, .el-table th>div{
      padding: 0 0 0 6px;
    }
  }
  .account-photo{
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 0;
    margin-right: 5px;
    float: left;
  }
  .unsafe-icon {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// workgroup-online-connection.vue?2ab5ba95